export const APP_NAME = "Digi Invite";